import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { Home, ArrowLeft } from 'lucide-react';
import { SEO } from '../components/seo/SEO';

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-csai-bg)]">
      <Header />

      <main className="flex-grow flex items-center justify-center px-4">
        <SEO
          title="Page Not Found"
          description="The page you're looking for doesn't exist or has been moved."
          canonical="https://situsai.ca"
          ogType="website"
        />

        <div className="text-center max-w-md">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <span className="text-3xl font-bold text-gray-300">404</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Page not found</h1>
          <p className="text-gray-500 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/">
              <Button className="rounded-full px-6">
                <Home className="w-4 h-4 mr-2" /> Back to Home
              </Button>
            </Link>
            <button
              onClick={() => window.history.back()}
              className="text-sm text-gray-500 hover:text-black transition-colors flex items-center gap-1"
            >
              <ArrowLeft className="w-4 h-4" /> Go back
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
